import React from 'react';

import NewSectionHeader from './NewSectionHeader';

export default function NewCardWithHeader({
  headerRightContent,
  heading,
  children,
  className,
  icon = null,
  padding = null,
  showHeader = true,
}) {
  return (
    <div className={className} style={{ padding: padding || '1.5rem 1.5rem .5rem' }}>
      {showHeader ? (
        <NewSectionHeader
          rightContent={headerRightContent}
          // displayBorder={displayBorder}
          icon={icon}
          heading={heading}
        />
      ) : null}

      {children}
    </div>
  );
}
